import React, {Fragment} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import H3 from "@irati/ui/src/Headings/H3"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import H4 from "@irati/ui/src/Headings/H4"
import padding from "@irati/ui/src/global/padding"
import {READY_TO_LAUNCH} from "@irati/insights/constants/schedule"
import Markdown from "@irati/ui/src/Markdown"
import * as fonts from "@irati/ui/src/global/fonts"

const Subtitle = styled(H4)`
  padding-top: ${padding.small}
`

const StyledMarkdown = styled(Markdown)`
  font-size: 18px;
  > p > strong {
    ${fonts.LatoBold};
  }
`

const Title = ({schedule, formatMessage}) => {
  const {reference} = schedule
  const hasErrors = !!schedule.validationErrors.length
  const isReadyToLaunch = schedule.validationStatus === READY_TO_LAUNCH
  if (hasErrors) {
    return (
      <Fragment>
        <H3> <Markdown source={formatMessage({id: "insights.wizard.step3.title"}, {reference})} /> </H3>
        <Subtitle> <StyledMarkdown source={formatMessage({id: "insights.wizard.step3.descriptionHasErrors"})} /> </Subtitle>
      </Fragment>
    )
  }

  if (isReadyToLaunch) {
    return (
      <Fragment>
        <H3> <Markdown source={formatMessage({id: "insights.wizard.step3.title"}, {reference})} /> </H3>
        <Subtitle> <StyledMarkdown source={formatMessage({id: "insights.wizard.step3.description"})} /> </Subtitle>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <H3> <FormattedMessage id="insights.wizard.step3.titleSaved" /> </H3>
    </Fragment>
  )
}

Title.propTypes = {
  schedule: PropTypes.object.isRequired,
  formatMessage: PropTypes.func.isRequired
}

export default injectIntl(Title)
